import React, { useState, useEffect } from 'react';
import './MarketerPromotionDialog.css';

function MarketerPromotionDialog({ contact, onClose, onPromote }) {
  const [mentorCompany, setMentorCompany] = useState(null);
  const [networkMemberId, setNetworkMemberId] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchMentorCompany();
  }, []);

  const fetchMentorCompany = async () => {
    try {
      const response = await fetch('/backend/api/admin/set-my-company.php', {
        credentials: 'include'
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          if (data.company) {
            setMentorCompany(data.company);
          } else {
            setError('Please configure your company in Admin Panel first');
          }
        } else {
          setError('Failed to load company information');
        }
      } else {
        setError('Failed to load company information');
      }
    } catch (error) {
      console.error('Error fetching mentor company:', error);
      setError('Failed to load company information');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!mentorCompany) {
      setError('Please configure your company in Admin Panel first');
      return;
    }
    
    if (!networkMemberId.trim()) {
      setError('Please enter the network member ID');
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      const response = await fetch('/backend/api/contacts/promote-to-marketer.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          contact_id: contact.id,
          action: 'promote',
          network_member_id: networkMemberId.trim()
        })
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          onPromote(data.contact);
          onClose();
        } else {
          setError(data.error || 'Failed to promote contact');
        }
      } else {
        setError('Server error occurred');
      }
    } catch (error) {
      console.error('Error promoting contact:', error);
      setError('Failed to promote contact');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="promotion-dialog-overlay" onClick={onClose}>
      <div className="promotion-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="promotion-dialog-header">
          <h2>🚀 Promote {contact.first_name} {contact.last_name} to Marketer</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        {loading ? (
          <div className="loading-state">Loading company information...</div>
        ) : (
          <form onSubmit={handleSubmit} className="promotion-form">
            <div className="company-display-section">
              <label>Network Company:</label>
              <div className="company-display-box">
                {mentorCompany ? (
                  <>
                    <span className="company-name">🏢 {mentorCompany.name}</span>
                    {mentorCompany.short_code && (
                      <span className="company-code">({mentorCompany.short_code})</span>
                    )}
                  </>
                ) : (
                  <span className="no-company-warning">⚠️ No company configured</span>
                )}
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="network-id">
                {mentorCompany?.id_field_label || 'Network ID'}:
              </label>
              <input
                type="text"
                id="network-id"
                value={networkMemberId}
                onChange={(e) => setNetworkMemberId(e.target.value)}
                placeholder={`Enter their ${mentorCompany?.id_field_label || 'Network ID'}...`}
                required
                disabled={!mentorCompany}
              />
            </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

            <div className="promotion-dialog-actions">
              <button 
                type="button" 
                className="cancel-btn"
                onClick={onClose}
                disabled={submitting}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="promote-btn"
                disabled={submitting || !mentorCompany || !networkMemberId.trim()}
              >
                {submitting ? 'Promoting...' : '🚀 Promote to Marketer'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default MarketerPromotionDialog;
